import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterLanguages = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterLanguages'),
);
